export const SHARES_FETCH = 'SHARES/FETCH';
export const SHARES_FETCH_SUCCESS = 'SHARES/FETCH_SUCCESS';
export const SHARES_FETCH_FAILURE = 'SHARES/FETCH_FAILURE';

export const SHARES_ADD = 'SHARES/ADD';
export const SHARES_ADD_PERSONAL = 'SHARES/ADD_PERSONAL';
export const SHARES_ADD_SUCCESS = 'SHARES/ADD_SUCCESS';
export const SHARES_ADD_FAILURE = 'SHARES/ADD_FAILURE';

export const SHARES_EDIT = 'SHARES/EDIT';
export const SHARES_EDIT_SUCCESS = 'SHARES/EDIT_SUCCESS';
export const SHARES_EDIT_FAILURE = 'SHARES/EDIT_FAILURE';

export const SHARES_DELETE = 'SHARES/DELETE';
export const SHARES_DELETE_SUCCESS = 'SHARES/DELETE_SUCCESS';

export const SHARES_REFRESH = 'SHARES/REFRESH';

export const SHARES_TOKEN_REFRESH = 'SHARES/TOKEN_REFRESH';
export const SHARES_TOKEN_REFRESH_SUCCESS = 'SHARES/TOKEN_REFRESH_SUCCESS';
export const SHARES_TOKEN_REFRESH_FAILURE = 'SHARES/TOKEN_REFRESH_FAILURE';

const initialState = [];

export const fetchShares = id => ({
  type: SHARES_FETCH,
  payload: { id },
});

export const addShare = ({ id, share }) => ({
  type: SHARES_ADD,
  payload: { id, share },
});

export const addPersonalShare = ({ id, share }) => ({
  type: SHARES_ADD_PERSONAL,
  payload: { id, share },
});

export const refreashToken = id => ({
  type: SHARES_TOKEN_REFRESH,
  payload: { id },
});

export const editShare = ({ id, share }) => ({
  type: SHARES_EDIT,
  payload: { id, share },
});

export const deleteShare = ({ bookletId, shareId }) => ({
  type: SHARES_DELETE,
  payload: { bookletId, shareId },
});

export const refreshShare = ({ bookletId, shareId }) => ({
  type: SHARES_REFRESH,
  payload: { bookletId, shareId },
});

export const sharesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SHARES_DELETE_SUCCESS: {
      const index = state.findIndex(share => share.id === payload.id);

      return [...state.slice(0, index), ...state.slice(index + 1)];
    }
    case SHARES_EDIT_SUCCESS: {
      const index = state.findIndex(share => share.id === payload.id);

      return [...state.slice(0, index), payload, ...state.slice(index + 1)];
    }
    case SHARES_FETCH: {
      return [];
    }
    case SHARES_ADD_SUCCESS: {
      return [...state, { ...payload }];
    }
    case SHARES_TOKEN_REFRESH_SUCCESS: {
      return [{ token: payload.token }];
    }
    case SHARES_FETCH_SUCCESS: {
      return [...state, ...payload];
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/shares.reducer.js